const phoneReg = /^1[3-9][0-9]{9}$/
const telReg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/
const passwordLength = /.{6,18}/
const passwordD = /\d+/
const passwordW = /[a-zA-Z]+/
const verifyCodeReg = /^\d{6}$/
const bankNumReg = /^([1-9]{1})(\d{14}|\d{18})$/
const positiveIntReg = /^[1-9]\d*$/
const positiveNumberReg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
const idCardReg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}$)/

const phoneNuReg = /^400[0-9]{7}|^1[3456789][0-9]{9}$|^0[0-9]{2,3}-[0-9]{7,9}$/

export default {
  isPhoneNu(phone) {
    return phoneReg.test(phone)
  },
  isTel(tel) {
    return telReg.test(tel)
  },
  isPhoneOrTelNu(phone) {
    return phoneNuReg.test(phone)
  },
  isPassword(password) {
    return passwordLength.test(password) && passwordD.test(password) && passwordW.test(password)
  },
  testVerifyCode(verifyCode) {
    return verifyCodeReg.test(verifyCode)
  },
  isBankNum(bankNum) {
    return bankNumReg.test(bankNum)
  },
  isPositiveInt(number) {
    return positiveIntReg.test(number)
  },
  isPositiveNumber(number) {
    return positiveNumberReg.test(number)
  },
  isIdCard(idCard) {
    return idCardReg.test(idCard)
  }
}



// WEBPACK FOOTER //
// ./src/utils/reg.js